import React, { useEffect, useState } from 'react';
import { Box, Typography, List, ListItem, ListItemAvatar, Avatar, ListItemText, CircularProgress, Divider, Paper } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { db } from './services/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

export default function AcquistiPage({ codiceCliente }: { codiceCliente: number }) {
  const [acquisti, setAcquisti] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAcquisti = async () => {
      setLoading(true);
      const acquistiTotali: any[] = [];

      // Query su transazioni (scontrini)
      const q1 = query(
        collection(db, 'transazioni'),
        where('cliente_id', '==', codiceCliente)
      );
      const snap1 = await getDocs(q1);
      snap1.forEach(doc => acquistiTotali.push({ ...doc.data(), id: doc.id, tipo: 'Automatica' }));

      // Query su transazioni_manuali
      const q2 = query(
        collection(db, 'transazioni_manuali'),
        where('cliente_id', '==', codiceCliente)
      );
      const snap2 = await getDocs(q2);
      snap2.forEach(doc => acquistiTotali.push({ ...doc.data(), id: doc.id, tipo: 'Manuale' }));

      // Ordina per data decrescente (campo: data_movimento_iso)
      acquistiTotali.sort((a, b) => {
        const dateA = new Date(a.data_movimento_iso).getTime();
        const dateB = new Date(b.data_movimento_iso).getTime();
        return dateB - dateA;
      });

      setAcquisti(acquistiTotali);
      setLoading(false);
    };

    if (codiceCliente) fetchAcquisti();
  }, [codiceCliente]);

  return (
    <Box sx={{ p: 2, width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Paper
        elevation={8}
        sx={{
          p: 3,
          width: '100%',
          maxWidth: 320,
          mx: 'auto',
          borderRadius: 4,
          display: 'flex',
          flexDirection: 'column',
          bgcolor: '#fff',
          mt: 2,
          textAlign: 'center'
        }}
      >
        <Typography variant="h5" sx={{ mb: 2, width: '100%' }}>
          I tuoi acquisti
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : acquisti.length === 0 ? (
          <>
            <Typography color="text.secondary" sx={{ mb: 2 }}>
              Qui potrai vedere i tuoi acquisti.
            </Typography>
            <Typography color="text.secondary">
              Nessun acquisto trovato.git 
            </Typography>
          </>
        ) : (
          <List sx={{ width: '100%' }}>
            {acquisti.map((item, idx) => (
              <React.Fragment key={item.id}>
                <ListItem>
                  <ListItemAvatar>
                    {item.tipo === 'Automatica' ? (
                      <Avatar sx={{ bgcolor: '#2a5298' }}>
                        <ReceiptLongIcon />
                      </Avatar>
                    ) : item.punti < 0 ? (
                      <Avatar sx={{ bgcolor: '#43a047' }}>
                        <CardGiftcardIcon />
                      </Avatar>
                    ) : (
                      <Avatar sx={{ bgcolor: '#ff9800' }}>
                        <PanToolAltIcon />
                      </Avatar>
                    )}
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      item.tipo === 'Automatica'
                        ? `Scontrino del ${new Date(item.data_movimento_iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })}`
                        : item.punti < 0
                          ? `Ritiro premio del ${new Date(item.data_movimento_iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })}`
                          : `Movimento manuale del ${new Date(item.data_movimento_iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })}`
                    }
                    secondary={
                      item.tipo === 'Automatica'
                        ? (
                          <>
                            <span>Importo: <b>€ {item.totale?.toFixed(2) ?? '--'}</b></span><br />
                            <span>Punti: <b>{item.punti ?? '--'}</b></span>
                          </>
                        )
                        : item.punti < 0
                          ? (
                            <>
                              <span>Decurtazione punti: <b>{item.punti}</b></span>
                            </>
                          )
                          : (
                            <>
                              <span>Aggiunti punti: <b>{item.punti}</b></span>
                            </>
                          )
                    }
                  />
                </ListItem>
                {idx < acquisti.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        )}
      </Paper>
    </Box>
  );
}